import {Component, computed, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {GeometryGraphNode, isGeometryAttributeValueLike, GeometryAttributeNode, GeometryAttributeSetNode} from "@cm/template-nodes"
import {GeometryAttributeValueLikeNodeInspectorComponent} from "@template-editor/components/inspectors/geometry-graph-node-inspector/components/geometry-attribute-value-like-node-inspector/geometry-attribute-value-like-node-inspector.component"
import {GeometryAttributeLikeNodeInspectorComponent} from "@template-editor/components/inspectors/geometry-graph-node-inspector/components/geometry-attribute-like-node-inspector/geometry-attribute-like-node-inspector.component"
import {GeometryAttributeSetLikeNodeInspectorComponent} from "@template-editor/components/inspectors/geometry-graph-node-inspector/components/geometry-attribute-set-like-node-inspector/geometry-attribute-set-like-node-inspector.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-geometry-graph-node-inspector",
    templateUrl: "./geometry-graph-node-inspector.component.html",
    styleUrls: ["./geometry-graph-node-inspector.component.scss"],
    standalone: true,
    imports: [GeometryAttributeValueLikeNodeInspectorComponent, GeometryAttributeLikeNodeInspectorComponent, GeometryAttributeSetLikeNodeInspectorComponent],
})
export class GeometryGraphNodeInspectorComponent extends BaseInspectorComponent<GeometryGraphNode<unknown>> {
    readonly $attributeLikeNode = computed(() => {
        const node = this.$node()
        return node instanceof GeometryAttributeNode ? node : null
    })
    readonly $attributeSetLikeNode = computed(() => {
        const node = this.$node()
        return node instanceof GeometryAttributeSetNode ? node : null
    })
    readonly $attributeValueLikeNode = computed(() => {
        const node = this.$node()
        return isGeometryAttributeValueLike(node) ? node : null
    })
}
